import { FileText, Banknote } from "lucide-react"
import { Badge } from "@/components/ui/badge"

export type SourceType = "tender" | "grant"

interface SourceBadgeProps {
	type: SourceType
	className?: string
	size?: "sm" | "md"
}

export function SourceBadge({ type, className = "", size = "sm" }: SourceBadgeProps) {
	const isGrant = type === "grant"
	const Icon = isGrant ? Banknote : FileText
	const label = isGrant ? "Subvenció" : "Licitació"
	const styles = isGrant
		? "text-amber-700 border-amber-200 bg-amber-50"
		: "text-[#2D8A5E] border-[#2D8A5E]/20 bg-[#2D8A5E]/5"

	const sizing = size === "md"
		? "text-[10px] px-1.5 py-0.5 gap-1"
		: "text-[9px] px-1.5 py-0 gap-1"
	const iconSize = size === "md" ? "h-3 w-3" : "h-2.5 w-2.5"

	return (
		<Badge variant="outline" className={`${sizing} ${styles} ${className}`}>
			<Icon className={iconSize} />
			{label}
		</Badge>
	)
}
